export const recruiterSubmenuItems = {
    companyInformation: { text: 'Company Information', path: '/company-information', langKey: 'submenu-company-information' },
    team: { text: 'People', path: '/people', langKey: 'submenu-people' },
};
